import React from "react";

const MetricsHeader = ({ isBrand, isCommerce}) => {
  return (
    <thead className="py-2 text-left text-gray-700 leading-4 bg-gray-100 rounded">
      <tr>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Cliente
        </th>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          DNI
        </th>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Fecha
        </th>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Hora
        </th>
        {isBrand ? (
          <th
            scope="col"
            className="p-2 border-r-2 border-r-gray-200 font-semibold"
          >
            Sucursal
          </th>
        ) : null}
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Importe s/Desc
        </th>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Desc. Aplicado
        </th>
        <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Total Abonado
        </th>
        {isCommerce ? (
          <th
            scope="col"
            className="p-2 border-r-2 border-r-gray-200 font-semibold"
          >
            Colaborador
          </th>
        ) : null}
        {(isBrand || isCommerce) &&
       ( <th
          scope="col"
          className="p-2 border-r-2 border-r-gray-200 font-semibold"
        >
          Anular Transacción
        </th>)

        }
      </tr>
    </thead>
  );
};

export default MetricsHeader;
